import { useTranslation } from 'react-i18next';
import { SearchPill } from '@kizen/kds/SearchPill';
import type { Bucket } from './useUsageBreakdownData';

type Props = {
  bucket: Bucket;
  value: string;
  onChange: (search: string) => void;
  loading: boolean;
};

export const UsageBreakdownSearch = ({
  bucket,
  value,
  onChange,
  loading,
}: Props) => {
  const { t } = useTranslation();

  return (
    <SearchPill
      inline
      value={value}
      onChange={onChange}
      placeholder={
        bucket === 'agentic-workflows' ? t('Find Workflows') : t('Find User')
      }
      loading={loading}
      qa={`ai-usage-${bucket}-search`}
    />
  );
};
